import { render, staticRenderFns } from "./SyncDeviceMontajNew.vue?vue&type=template&id=ebf1fa84"
import script from "./SyncDeviceMontajNew.vue?vue&type=script&lang=js"
export * from "./SyncDeviceMontajNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports